(() => {
  const ROOT_SELECTOR='[data-eg-used-quality]';
  const normalize=(value='')=>String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();
  const canonicalCondition=(value='')=>{
    const v=normalize(value);
    if(v==='regular'||v==='aceptable')return 'Aceptable';
    if(v==='como nuevo')return 'Como nuevo';
    if(v==='excelente')return 'Excelente';
    if(v==='bueno')return 'Bueno';
    return String(value).trim();
  };
  const gradeLevel=(value)=>{
    const v=normalize(value);
    if(v.includes('como nuevo')||v==='nuevo')return 5;
    if(v.includes('excelente'))return 4;
    if(v.includes('bueno'))return 3;
    if(v.includes('regular')||v.includes('aceptable'))return 2;
    return 0;
  };
  const contentLevel=(value)=>{
    const v=normalize(value);
    if(!v)return 0;
    if(v.includes('casi completo')||v.includes('mayormente completo'))return 4;
    if(v.includes('incompleto'))return 2;
    if(v.includes('parcial'))return 3;
    if(v.includes('solo producto')||v.includes('solo disco')||v.includes('solo cartucho')||v.includes('sin caja'))return 1;
    if(v.includes('completo'))return 5;
    return gradeLevel(value);
  };

  const markOriginalUsedBadge=()=>{
    const info=document.querySelector('product-info');
    if(!info)return;
    info.querySelectorAll('[data-eg-merch-badge],[data-eg-badge],.eg-product-price-badge').forEach((badge)=>{
      if(normalize(badge.textContent)==='usado')badge.classList.add('eg-used-price-used-badge--suppressed');
    });
  };
  const readCondition=()=>{
    const radios=[...document.querySelectorAll('product-info input[type="radio"][data-option-name]:checked')];
    const radio=radios.find((el)=>normalize(el.dataset.optionName)==='condicion');
    if(radio)return radio.value;
    const selected=[...document.querySelectorAll('product-info select option:checked[data-option-name]')];
    const option=selected.find((el)=>normalize(el.dataset.optionName)==='condicion');
    if(option)return option.value;
    return document.querySelector(ROOT_SELECTOR)?.dataset.currentCondition||'';
  };
  const normalizeConditionControls=()=>{
    const info=document.querySelector('product-info');
    if(!info)return;
    info.querySelectorAll('input[data-option-name]').forEach((input)=>{
      if(normalize(input.dataset.optionName)!=='condicion'||normalize(input.value)!=='regular')return;
      const label=input.labels?.[0];if(label&&normalize(label.textContent)==='regular')label.textContent='Aceptable';
    });
    info.querySelectorAll('select').forEach((select)=>{
      const selectedOption=select.querySelector('option:checked');const optionName=select.dataset.optionName||selectedOption?.dataset.optionName||'';
      if(normalize(optionName)!=='condicion')return;
      select.querySelectorAll('option').forEach((option)=>{if(normalize(option.textContent)==='regular')option.textContent='Aceptable';});
    });
  };
  const isContentRow=(row)=>row.hasAttribute('data-eg-used-content-row')||normalize(row.querySelector('.eg-used-check__label')?.textContent||'').includes('contenido');
  const applyMeters=(scope=document)=>scope.querySelectorAll('[data-eg-used-grade-row]').forEach((row)=>{const value=row.dataset.gradeValue||row.querySelector('[data-eg-used-grade-value]')?.textContent||'';row.dataset.gradeLevel=String(isContentRow(row)?contentLevel(value):gradeLevel(value));});
  const hideRedundantUsedState=()=>{
    const info=document.querySelector('product-info');if(!info)return;
    info.querySelectorAll('fieldset,.product-form__input,.product-form__input--dropdown').forEach((wrapper)=>{
      const label=wrapper.querySelector('legend,.form__label,label');if(!label||normalize(label.textContent)!=='estado')return;
      const selected=wrapper.querySelector('input:checked,select option:checked');const value=selected?.value||selected?.textContent||'';
      if(['usado','usados'].includes(normalize(value))){wrapper.hidden=true;wrapper.dataset.egUsedStateHidden='true';}
    });
  };
  const syncCondition=()=>{
    const root=document.querySelector(ROOT_SELECTOR);if(!root)return;
    normalizeConditionControls();const value=canonicalCondition(readCondition()||root.dataset.currentCondition||'');if(!value)return;
    root.dataset.currentCondition=value;root.querySelectorAll('[data-eg-used-current-condition]').forEach((node)=>node.textContent=value);document.querySelectorAll('[data-eg-used-pdp-condition]').forEach((node)=>node.textContent=value);
    const normalized=normalize(value);let matched=false;
    root.querySelectorAll('[data-eg-used-grade-card]').forEach((card)=>{const current=normalize(canonicalCondition(card.dataset.condition))===normalized;card.classList.toggle('is-current',current);if(current){card.setAttribute('aria-current','true');matched=true;}else card.removeAttribute('aria-current');});
    const special=root.querySelector('[data-eg-used-special-condition]');if(special){special.hidden=matched;special.classList.toggle('is-current',!matched);if(!matched)special.setAttribute('aria-current','true');else special.removeAttribute('aria-current');const label=special.querySelector('[data-eg-used-special-value]');if(label&&!matched)label.textContent=value;}
    const overall=root.querySelector('[data-eg-used-overall-row]');if(overall){overall.dataset.gradeValue=value;overall.dataset.gradeLevel=String(gradeLevel(value));}
    document.dispatchEvent(new CustomEvent('easygames:used-condition-change',{detail:{condition:value}}));
  };
  const refresh=()=>{const root=document.querySelector(ROOT_SELECTOR);if(!root)return;document.documentElement.classList.add('eg-used-product-page');markOriginalUsedBadge();normalizeConditionControls();applyMeters(root);syncCondition();hideRedundantUsedState();};
  const init=()=>{
    if(!document.querySelector(ROOT_SELECTOR))return;refresh();
    document.addEventListener('change',(event)=>{const target=event.target instanceof Element?event.target:null;if(!target?.closest('product-info'))return;const name=target.dataset?.optionName||target.querySelector?.('option:checked')?.dataset?.optionName||'';if(normalize(name)==='condicion'){requestAnimationFrame(refresh);setTimeout(refresh,280);}},true);
    document.addEventListener('shopify:section:load',()=>requestAnimationFrame(refresh));
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();
